import envConfig from '../../env/index.js';

const Env = {
  APP_ENV: envConfig?.FLEET_APP_ENV,

  APP_NAME: process.env.APP_NAME,

  APP_VERSION: process.env.APP_VERSION,

  APP_COMMIT_VERSION: process.env.APP_COMMIT_VERSION,

  APP_API_ENV: envConfig?.FLEET_APP_API_ENV,

  APP_OLD_API_ENV: envConfig?.FLEET_APP_OLD_API_ENV,

  OB_DRIVER_PAGE: envConfig?.FLEET_OB_DRIVER_PAGE,

  OB_CAR_PAGE: envConfig?.FLEET_OB_CAR_PAGE,

  OB_DOCUMENT_PAGE: envConfig?.FLEET_OB_DOCUMENT_PAGE,

  OLD_PAGE: envConfig?.FLEET_OLD_PAGE,

  DRIVER_INFO_PAGE: envConfig?.FLEET_DRIVER_INFO_PAGE,

  FEEDBACK_PAGE: envConfig?.FLEET_FEEDBACK_PAGE,

  MATCHING_PAGE: envConfig?.FLEET_MATCHING_PAGE,

  AUDIT_PROGRESS: envConfig?.FLEET_OB_AUDIT_PROGRESS,

  FLEET_APP2_PAGE: envConfig?.FLEET_APP2_PAGE,

  PAY_PAYGE: envConfig?.FLEET_PAY_PAYGE,

  PAY_API: envConfig?.FLEET_PAY_API,

  ADD_BANK: envConfig?.FLEET_ADD_BANK,

  ADD_BANK_MX: envConfig?.FLEET_MX_ADD_BANK,

  ADD_BANK_99: envConfig?.FLEET_99_ADD_BANK,

  PAY_INVOICE: envConfig?.FLEET_PAY_INVOICE,

  DRIVER_INFO_CITY: envConfig?.FLEET_DRIVER_INFO_CITY,
};

export default Env;
